import { FIELD__base } from '../FIELD__base';

export function FN_FIELD_CONTAINER__get_fields(target: any) {
  let out: FIELD__base[] = [];

  for (let field of Object.values(target)) {
    if (!(field instanceof FIELD__base)) continue;

    out.push(field);

    let children = FN_FIELD_CONTAINER__get_fields(field);
    out = [...out, ...children];
  }

  return out;
}
